// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"dba173b1","104":"ae52502a","598":"7ae1a054","625":"a24e4f3e","713":"6f9e9de9"}[chunkId] + ".chunk.css";
};